interface TabOption<T extends string> {
  value: T;
  label: string;
}

interface TabSelectorProps<T extends string> {
  options: TabOption<T>[];
  value: T;
  onChange: (value: T) => void;
  className?: string;
  variant?: 'default' | 'compact';
}

export function TabSelector<T extends string>({ 
  options, 
  value, 
  onChange,
  className = '',
  variant = 'default',
}: TabSelectorProps<T>) {
  const containerClasses =
    variant === 'compact'
      ? 'flex gap-1 bg-secondary/60 p-1 rounded-lg'
      : 'flex gap-2 bg-secondary p-1 rounded-lg';

  const activeClasses =
    variant === 'compact'
      ? 'bg-gray-200 text-gray-800 font-semibold'
      : 'bg-gray-200 text-gray-800 font-extrabold';

  const inactiveClasses =
    variant === 'compact'
      ? 'text-text-secondary hover:text-text-primary text-sm'
      : 'text-text-secondary hover:text-text-primary';

  return (
    <div className={`${containerClasses} ${className}`}>
      {options.map((option) => (
        <button
          key={option.value}
          onClick={() => onChange(option.value)}
          className={`flex-1 ${variant === 'compact' ? 'py-1 px-3 text-sm' : 'py-1 px-4'} rounded-md font-medium transition-colors ${
            value === option.value
              ? activeClasses
              : inactiveClasses
          }`}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}

